export const PRODUCT_NAME = "Sport Connect";
export const PRODUCT_NAME_POSSESSIVE = "Sport Connect ID's";